(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artist-feature"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DESKTOP = '(min-width: 990px)';
    var REDUCE = '(prefers-reduced-motion: reduce)';
    var instances = new Map();

    function ArtistFeature(root) {
      this.root = root;
      this.items = Array.prototype.slice.call(root.querySelectorAll('[data-af-item]'));
      this.visible = new Set();
      this.ticking = false;
      this.parallaxOn = false;
      this.listening = false;
      this.onScroll = this.onScroll.bind(this);
      this.update = this.update.bind(this);
      this.onMedia = this.onMedia.bind(this);
      this.init();
    }

    ArtistFeature.prototype.init = function () {
      var self = this;
      var reduce = window.matchMedia(REDUCE).matches;
      var designMode = window.Shopify && window.Shopify.designMode;

      this.root.classList.add('af--js');

      // Sticky fix: theme wrappers with overflow hidden/auto stop position: sticky working.
      // Switch those to overflow: clip, which clips the same but doesn't block sticky.
      var root = this.root;
      fixStickyAncestors(root);
      // Run again after the theme's own scripts and styles have finished loading
      window.addEventListener('load', function () { fixStickyAncestors(root); });
      setTimeout(function () { fixStickyAncestors(root); }, 1500);

      // Reveal on enter
      if (reduce || designMode || !('IntersectionObserver' in window)) {
        this.items.forEach(function (el) { el.classList.add('is-visible'); });
      } else {
        this.revealObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('is-visible');
              self.revealObs.unobserve(e.target);
            }
          });
        }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });
        this.items.forEach(function (el) { self.revealObs.observe(el); });
      }

      if ('IntersectionObserver' in window) {
        // Images near the viewport (parallax only updates these)
        this.viewObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) self.visible.add(e.target);
            else self.visible.delete(e.target);
          });
          self.requestTick();
        }, { rootMargin: '25% 0px 25% 0px' });
        this.items.forEach(function (el) { self.viewObs.observe(el); });
      }

      this.mqDesktop = window.matchMedia(DESKTOP);
      this.mqReduce = window.matchMedia(REDUCE);
      this.mqDesktop.addEventListener('change', this.onMedia);
      this.mqReduce.addEventListener('change', this.onMedia);
      this.onMedia();
    };

    ArtistFeature.prototype.onMedia = function () {
      this.parallaxOn = this.mqDesktop.matches &&
        this.root.dataset.parallax === 'true' && !this.mqReduce.matches;

      if (!this.parallaxOn) {
        this.items.forEach(function (el) {
          var p = el.querySelector('[data-af-parallax]');
          if (p) p.style.transform = '';
        });
      }

      var want = this.parallaxOn;
      if (want && !this.listening) {
        this.listening = true;
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
      } else if (!want && this.listening) {
        this.listening = false;
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
      this.requestTick();
    };

    ArtistFeature.prototype.onScroll = function () { this.requestTick(); };

    ArtistFeature.prototype.requestTick = function () {
      if (!this.parallaxOn || this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(this.update);
    };

    ArtistFeature.prototype.update = function () {
      this.ticking = false;
      if (!this.parallaxOn) return;
      var half = window.innerHeight / 2;
      var writes = [];
      // Read all positions first, then write. Measure the untransformed item, move its inner wrapper.
      this.visible.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var speed = parseFloat(el.dataset.speed) || 0;
        writes.push([el.querySelector('[data-af-parallax]'), -(r.top + r.height / 2 - half) * speed * 0.015]);
      });
      writes.forEach(function (w) {
        if (w[0]) w[0].style.transform = 'translate3d(0,' + w[1].toFixed(2) + 'px,0)';
      });
    };

    ArtistFeature.prototype.destroy = function () {
      if (this.revealObs) this.revealObs.disconnect();
      if (this.viewObs) this.viewObs.disconnect();
      this.mqDesktop.removeEventListener('change', this.onMedia);
      this.mqReduce.removeEventListener('change', this.onMedia);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    };

    function fixStickyAncestors(root) {
      var html = document.documentElement;
      var body = document.body;
      var hcs = getComputedStyle(html);
      var htmlVisible = hcs.overflowY === 'visible' && hcs.overflowX === 'visible';
      var blocks = function (v) { return v === 'hidden' || v === 'auto' || v === 'scroll'; };
      var el = root;
      while (el && el !== html) {
        // body's overflow is passed to the viewport when html's is visible, so it doesn't block sticky
        if (el === body && htmlVisible) break;
        var cs = getComputedStyle(el);
        var realScroller = (cs.overflowY === 'auto' || cs.overflowY === 'scroll') &&
          el.scrollHeight > el.clientHeight + 1;
        if ((blocks(cs.overflowX) || blocks(cs.overflowY)) && !realScroller) {
          // !important so theme rules marked !important can't win
          el.style.setProperty('overflow-x', cs.overflowX === 'visible' ? 'visible' : 'clip', 'important');
          el.style.setProperty('overflow-y', cs.overflowY === 'visible' ? 'visible' : 'clip', 'important');
          if (window.console) console.info('[artist-feature] unblocked sticky on', el);
        }
        el = el.parentElement;
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-af]').forEach(function (root) {
        if (!instances.has(root)) instances.set(root, new ArtistFeature(root));
      });
    }

    function destroyIn(scope) {
      scope.querySelectorAll('[data-af]').forEach(function (root) {
        var inst = instances.get(root);
        if (inst) { inst.destroy(); instances.delete(root); }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) { destroyIn(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finstark-triple-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function isMobile() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    function initGallery(list) {
      if (!list || list.dataset.triInit === 'true') return;
      list.dataset.triInit = 'true';

      const root = list.closest('section');
      if (!root) return;

      const mode            = list.getAttribute('data-mobile-mode');
      const dotsWrap        = root.querySelector('.tri-strip__dots');
      const autoplay        = list.getAttribute('data-autoplay') === 'true';
      const speed           = parseInt(list.getAttribute('data-autoplay-speed') || '3500', 10);
      const isDesktopSlider = list.getAttribute('data-desktop-slider') === 'true';

      /* Mobile carousel: dots, drag-to-scroll, autoplay */
      if (mode === 'carousel' && isMobile()) {
        const items = Array.from(list.children);

        if (dotsWrap) {
          dotsWrap.innerHTML = items
            .map((_, i) => `<button type="button" aria-current="${i === 0 ? 'true' : 'false'}" aria-label="Go to slide ${i + 1}"></button>`)
            .join('');

          const dots = Array.from(dotsWrap.querySelectorAll('button'));

          function updateDots() {
            const idx = Math.round(list.scrollLeft / list.clientWidth);
            dots.forEach((d, i) => d.setAttribute('aria-current', String(i === idx)));
          }

          list.addEventListener('scroll', () => window.requestAnimationFrame(updateDots), { passive: true });
          dots.forEach((d, i) =>
            d.addEventListener('click', () => list.scrollTo({ left: i * list.clientWidth, behavior: 'smooth' }))
          );
        }

        let isDown = false;
        let startX = 0;
        let startLeft = 0;
        let timer = null;

        list.addEventListener('pointerdown', (e) => {
          isDown = true;
          startX = e.clientX;
          startLeft = list.scrollLeft;
          list.setPointerCapture(e.pointerId);
          if (timer) clearTimeout(timer);
        });
        list.addEventListener('pointermove', (e) => {
          if (!isDown) return;
          list.scrollLeft = startLeft - (e.clientX - startX);
        });
        list.addEventListener('pointerup', () => {
          isDown = false;
          if (autoplay) tick();
        });

        function tick() {
          timer = setTimeout(() => {
            const maxIdx = items.length - 1;
            const curr = Math.round(list.scrollLeft / list.clientWidth);
            const next = curr >= maxIdx ? 0 : curr + 1;
            list.scrollTo({ left: next * list.clientWidth, behavior: 'smooth' });
            tick();
          }, speed);
        }
        if (autoplay) tick();
      }

      /* Desktop overflow slider: arrows + drag-to-scroll */
      if (isDesktopSlider) {
        const arrowsWrap = root.querySelector('.tri-strip__arrows--desktop');
        const prevBtn = arrowsWrap && arrowsWrap.querySelector('.tri-strip__arrow--prev');
        const nextBtn = arrowsWrap && arrowsWrap.querySelector('.tri-strip__arrow--next');

        function tileStep() {
          const item = list.querySelector('.tri-strip__item');
          if (!item) return list.clientWidth;
          const style = getComputedStyle(list);
          const gap = parseFloat(style.columnGap || style.gap || '0');
          return item.getBoundingClientRect().width + gap;
        }

        function updateArrows() {
          if (!prevBtn || !nextBtn) return;
          const max = list.scrollWidth - list.clientWidth - 1;
          prevBtn.disabled = list.scrollLeft <= 0;
          nextBtn.disabled = list.scrollLeft >= max;
        }

        if (prevBtn) prevBtn.addEventListener('click', () => list.scrollBy({ left: -tileStep(), behavior: 'smooth' }));
        if (nextBtn) nextBtn.addEventListener('click', () => list.scrollBy({ left: tileStep(), behavior: 'smooth' }));
        list.addEventListener('scroll', () => window.requestAnimationFrame(updateArrows), { passive: true });
        updateArrows();

        let dIsDown = false;
        let dStartX = 0;
        let dStartLeft = 0;

        list.addEventListener('pointerdown', (e) => {
          if (isMobile() || e.pointerType === 'touch') return;
          dIsDown = true;
          dStartX = e.clientX;
          dStartLeft = list.scrollLeft;
          list.setPointerCapture(e.pointerId);
        });
        list.addEventListener('pointermove', (e) => {
          if (!dIsDown) return;
          list.scrollLeft = dStartLeft - (e.clientX - dStartX);
        });
        list.addEventListener('pointerup', () => {
          dIsDown = false;
        });
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.tri-strip__list').forEach(initGallery);
    }

    initAll();

    /* Theme editor: re-init when this section is added or edited */
    document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
